import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import About from "@/pages/About";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Apply from "@/pages/Apply";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="industries" element={<Industries />} />
          <Route path="about" element={<About />} />
          <Route path="careers" element={<Careers />} />
          <Route path="apply" element={<Apply />} />
          <Route path="contact" element={<Contact />} />
        </Route>
        <Route path="/admincontrol/login" element={<><AdminLogin /><Toaster richColors position="bottom-right" /></>} />
        <Route path="/admincontrol" element={<><AdminDashboard /><Toaster richColors position="bottom-right" /></>} />
        <Route path="/admin/login" element={<Navigate to="/admincontrol/login" replace />} />
        <Route path="/admin" element={<Navigate to="/admincontrol" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
